import { ref, Ref, watch } from "@vue/composition-api";

export default function usePlayer<T extends HTMLMediaElement>(player: Ref<T | undefined>) {
  const isMediaPlaying = ref(false);

  const play = () => {
    if (!player.value) return;
    player.value.play().then();
  };

  const pause = () => {
    if (!player.value) return;
    player.value.pause();
  };

  const setVideoStartTime = (time: number) => {
    if (!player.value) return;
    player.value.currentTime = time;
  };

  const init = () => {
    if (!player.value) return;
    player.value.onplay = () => {
      isMediaPlaying.value = true;
    };
    player.value.onpause = () => {
      isMediaPlaying.value = false;
    };
  };

  watch(player, () => init());

  return {
    isMediaPlaying,
    play,
    pause,
    setVideoStartTime,
  };
}
